import './src/styles/fonts.css';
import './src/styles/globals.css'
import './src/styles/common.css'   
import React from 'react';
import RootElement from './src/components/root-element';

export const wrapRootElement = ({ element }) => {
    return <RootElement>{element}</RootElement>;
  };